import { findKey } from "lodash";
import {
    isValidListBuilderName,
    isValidListBuilderLocationMinMaxCount,
} from "../../../service/validation";
import { FormParams } from "../enums/form-params";
import { ListBuilderLists } from "../enums/list-options";
import { IListBuilderDetailsBodyDto } from "../interface/dto/list-builder-details.dto";
import { IError } from "../interface/form";

const isSelectRequired = (
    value: Array<number | string>,
    name: string,
    plural?: boolean,
) => {
    if (!value?.length) {
        return `${name} ${plural ? "are" : "is"} required.`;
    }
    return undefined;
};

export const validate = (form: IListBuilderDetailsBodyDto) => {
    let validationResult: IError = {};

    if (!isValidListBuilderName(form[FormParams.NAME])) {
        validationResult = {
            [FormParams.NAME]: "Please enter valid builder name",
        };
    }

    if (
        form[FormParams.LISTS] !== ListBuilderLists.ALL &&
        !form[FormParams.ADD_TRACKED_LISTS]
    ) {
        const errorText = "Atleast one list";

        const listsSectionError = {
            [FormParams.SIC_CODES]: isSelectRequired(
                form[FormParams.SIC_CODES],
                errorText,
            ),
            [FormParams.NAICS_CODES]: isSelectRequired(
                form[FormParams.NAICS_CODES],
                errorText,
            ),
            [FormParams.LISTIDS]: isSelectRequired(
                form[FormParams.LISTIDS],
                errorText,
            ),
            [FormParams.CATEGORIES]: isSelectRequired(
                form[FormParams.CATEGORIES],
                errorText,
            ),
        };

        const keyName = findKey(listsSectionError, (value) => !value);

        if (!keyName) {
            validationResult = { ...listsSectionError, ...validationResult };
        }
    }

    if (
        !form[FormParams.USE_LIST_COLUMNS] &&
        !form[FormParams.COLUMNS].length
    ) {
        validationResult = {
            ...validationResult,
            [FormParams.COLUMNS]: isSelectRequired(
                form[FormParams.COLUMNS],
                "Columns",
                true,
            ),
        };
    }

    if (form[FormParams.ADD_SNAPSHOTS] && !form[FormParams.SNAPSHOT_DATE]) {
        validationResult = {
            ...validationResult,
            [FormParams.SNAPSHOT_DATE]: "Please Enter A Valid Date",
        };
    }

    if (
        !isValidListBuilderLocationMinMaxCount(
            form[FormParams.MIN_LOCATION_COUNT],
            form[FormParams.MAX_LOCATION_COUNT],
        )
    ) {
        validationResult = {
            ...validationResult,
            [FormParams.MIN_LOCATION_COUNT]:
                "Minimum location count can’t be greater than maximum location count",
        };
    }
    return validationResult;
};
